import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Modal, ModalActions, ModalContent, ModalHeader } from 'semantic-ui-react';

// eslint-disable-next-line react/prop-types
function ModalAlertNotEligibleIssueMC({ setOpen }) {
  const { error } = useSelector(state => state.webChat.contextMenu);
  const message = error?.isEligibleIssueMC?.data?.message ?? 'Cannot Issue MC';
  return (
    <Modal onClose={() => setOpen(false)} onOpen={() => setOpen(true)} open size="tiny">
      <ModalHeader>Cannot Issue MC</ModalHeader>
      <ModalContent>{message}</ModalContent>
      <ModalActions>
        <Button primary onClick={() => setOpen(false)}>
          Understand
        </Button>
      </ModalActions>
    </Modal>
  );
}

export default ModalAlertNotEligibleIssueMC;
